import api from './api';

export const AWAY_WINDOW_CHANGED_EVENT = 'teamlio:away-window-changed';

function announceAwayWindowChange(): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(AWAY_WINDOW_CHANGED_EVENT));
}

export interface AwayWindow {
  id: string;
  user_id: string;
  starts_at: string;
  ends_at: string;
  ended_at?: string | null;
  status_type?: 'away' | 'dnd';
  note?: string | null;
}

export interface AwayWindowPayload {
  starts_at: string;
  ends_at: string;
  status_type?: 'away' | 'dnd';
  note?: string | null;
}

export async function getMyAway(): Promise<AwayWindow | null> {
  const res = await api.get('/away/me');
  return res.data?.data ?? null;
}

export async function setAwayWindow(payload: AwayWindowPayload): Promise<AwayWindow> {
  const res = await api.post('/away', payload);
  const window = res.data?.data;
  announceAwayWindowChange();
  return window;
}

export async function endAwayNow(): Promise<boolean> {
  const res = await api.post('/away/end');
  const ended = !!res.data?.ended;
  if (ended) announceAwayWindowChange();
  return ended;
}

export async function setAttendancePresence(clockedIn: boolean): Promise<void> {
  await api.post('/away/attendance', { clocked_in: clockedIn });
}

export interface AwayBackReminderResult {
  success: boolean;
  already_set: boolean;
}

export async function remindWhenBack(
  awayWindowId: string,
  conversationId?: string | null,
): Promise<AwayBackReminderResult> {
  const res = await api.post(`/away/${awayWindowId}/remind-back`, {
    conversation_id: conversationId || null,
  });
  return res.data;
}
